export default {
    'emptyField': 'This field should not be empty.',
    'emailValidationText': 'Please enter a valid email.',
    'passwordValidationText': 'Password should be at least 6 characters long.',
    'passwordLength': 'Password should be at least 6 characters long.',
    'matchPassword': 'Passwords do not match!'
}